import { Box, Button, Container, Typography } from "@mui/material";
import { ReactComponent as IconForward } from "../../assets/icons/iconforward.svg";
import { ReactComponent as IconDownload } from "../../assets/icons/icondownload.svg";
import React from "react";
import { Link } from "react-router-dom";

const FooterLP = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#000",
        color: "#fff",
        pt: { xs: 6, md: 10 },
        pb: 4,
      }}
    >
      <Container maxWidth={false} sx={{ width: "92%", mx: "auto" }}>
        {/* Heading */}
        <Typography
          align="center"
          sx={{
            fontWeight: 700,
            fontSize: { xs: "28px", md: "33px" },
            lineHeight: 1.4,
            mb: 2,
          }}
        >
          いまのMicrosoft 365のまま、
          <br />
          業務はここまで変えられる。
        </Typography>

        {/* Short subtext */}
        <Typography
          align="center"
          sx={{
            fontSize: "14px",
            color: "rgba(255,255,255,0.7)",
            mb: 2,
          }}
        >
          追加のSaaSもサーバーもなしで、御社の業務に合わせたポータルを作ります。
        </Typography>

        {/* Long description */}
        <Typography
          align="center"
          sx={{
            fontSize: "14px",
            color: "rgba(255,255,255,0.85)",
            // maxWidth: "800px",
            mx: "auto",
            lineHeight: 1.8,
            mb: 4,
          }}
        >
          追加のSaaSもサーバーもなしで、御社の業務に合わせたポータルを作ります。無料相談では、現在のM365環境を伺った <br />うえで、どこまで実現できるかを具体的にお伝えします。その場でお決めいただく必要はありません。
        </Typography>

        {/* CTA buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: 2,
            mb: 6,
          }}
        >
          <Button
            variant="contained"
            endIcon={<Box component={IconForward} sx={{width: 15, height: 15}} />}
            sx={{
              backgroundColor: "#FF6000",
              color: "#fff",
              borderRadius: "7px",
              textTransform: "none",
              fontWeight: 700,
              fontSize: "16px",
              px: 4,
              py: 1.5,
              "&:hover": {
                backgroundColor: "#e55500",
              },
            }}
          >
            無料で相談・デモを申し込む
          </Button>

          <Button
            variant="outlined"
            endIcon={<Box component={IconDownload} sx={{width: 15, height: 15}} />}
            sx={{
              backgroundColor: "#fff",
              borderColor: "#fff",
              color: "#000",
              borderRadius: "7px",
              textTransform: "none",
              fontWeight: 700,
              fontSize: "16px",
              px: 4,
              py: 1.5,
              "&:hover": {
                backgroundColor: "#f0f0f0",
                borderColor: "#fff",
              },
            }}
          >
            無料で資料をダウンロード
          </Button>
        </Box>

        {/* Bottom bar: brand + privacy link */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            maxWidth: '500px',
            margin: 'auto',
            gap: 2,
            mb: 3,
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              letterSpacing: "1px",
            }}
          >
            GLOBAL JAPAN NETWORK
          </Typography>

          <Link
            to="/privacy-policy"
            style={{
              color: "#fff",
              fontSize: "14px",
              textDecoration: "none",
            }}
          >
            プライバシーポリシー
          </Link>
        </Box>

        {/* Copyright */}
        <Typography
          align="center"
          sx={{
            fontSize: "11px",
            padding: '10px 0',
            letterSpacing: 'initial',
            color: "rgba(255,255,255,0.6)",
          }}
        >
          © GLOBAL JAPAN NETWORK Inc.
        </Typography>
      </Container>
    </Box>
  );
};

export default FooterLP;